<template>
  <div class="">
    <!-- tab栏 -->
    <van-tabs v-model="activeTab" @change="getActiveTab">
      <van-tab
          v-for="item in statusList"
          :key="item.id"
          :name="item.id"
          :title="item.name"
      ></van-tab>
    </van-tabs>
    <!-- 搜索框 -->
    <van-search
        v-model="name"
        placeholder="请输入搜索关键词"
        @search="onSearch"
        @cancel="onCancel"
    />
    <!-- 卡片 -->
    <van-list
        v-model="loading"
        :finished="finished"
        offset="20"
        :immediate-check="false"
        @load="onLoad"
        finished-text="没有更多了 ~"
    >
      <div
          style="width: 100%; border-bottom:1px solid #EAEAEB"
          v-for="(item, index) in list"
          :key="index"
          @click="handleSuccess2(item)"
      >
        <div class="box">
          <div class="top">
            <div style="flex:1">
              <span class="Name" style="display: inline-block;">{{
                  item.applyMan | returnFloat
                }}</span>
              <!-- <img src="../../assets/image/已发起.png" alt="" /> -->
              <span class="title"
              >{{ item.applyMan }}发起了{{ item.customName }}</span
              >
            </div>
            <span class="time">{{ item.applyTime | formatTime }}</span>
          </div>
          <div class="des" style="margin-top: 10px">
            <div class="time">分组类型:{{ item.tptGroupName }}</div>
            <div class="time">模板名称:{{ item.tptName }}</div>
            <!-- <div class="time">请假类型:年假</div>
            <div class="time">开始时间:2024-04-13</div>
            <div class="time">结束时间:2024-04-13</div> -->
          </div>
          <div class="result">
            <span v-if="item.result == 1" style="color:#FF8165">审核中</span>
            <span v-if="item.result == 2">完成</span>
            <span v-if="item.result == 3" style="color: #ebb563">撤回</span>
            <span v-if="item.result == 4" style="color:#FF8165">拒绝</span>
            <span v-if="item.result == 6" style="color:#ebb563">代办</span>
            <span v-if="item.result == 7" style="color:#ebb563">重新发起</span>
          </div>
        </div>
      </div>
    </van-list>
  </div>
</template>

<script>
import {
  getFormGroups,
  SubmitInstance,
  GetMyFlowInstancePage,
  GetFlowInstancePage,
  GetFlowInstance,
  VerifyInstance,
  GetOpeateRecList,
  DeleteInstance,
} from "@/api/design";

export default {
  // 组件名称
  name: "",
  // 组件参数 接收来自父组件的数据
  props: {},
  // 局部注册的组件
  components: {},
  // 组件状态值
  data() {
    return {
      hidden: true, //没有更多数据了
      loading: false, //加载
      finished: false, //数据完全加载结束为 true
      list: [],
      showBoolean: false,
      activeTab: null,
      name: null,
      flag: "",
      page: 1,
      statusList: [
        {
          id: 1,
          name: "待处理",
        },
        {
          id: 2,
          name: "已处理",
        },
        {
          id: 3,
          name: "已发起",
        },
        {
          id: 4,
          name: "我收到的",
        },
      ],
    };
  },
  filters: {
    returnFloat(val) {
      if (val.length <= 2) {
        return val;
      } else {
        return val.slice(-2);
      }
    },
    formatTime(val) {
      return val.split(" ")[0];
    },
  },
  // 计算属性
  computed: {},
  // 侦听器
  watch: {},
  // 组件方法
  methods: {
    getList() {
      this.showBoolean = true;
      GetFlowInstancePage({
        userId: this.$route.params.userId,
        platformId: this.$route.params.platformId,
        companyId: this.$route.params.companyId,
        pageNum: this.page,
        pageSize: 10,
        flag: this.flag,
        customName: this.name,
      }).then((res) => {
        if (res.code == 200) {
          this.showBoolean = false;
          let rows = res.data.list;
          this.list = this.list.concat(rows);
          console.log(this.list);
          this.loading = false;
          if (!res.data.hasNextPage) {
            // 加载结束 => 没有下一页
            console.log("结束");
            this.finished = true;
          } else {
            this.finished = false;
          }
          console.log(this.list, "list");
        }
      });
    },

    handleSuccess2(row) {
      if (row.result == 7) {
        console.log("进来了")
        //直接重新发起
        var path =
            "/approval/" +
            row.tptId +
            "/" +
            this.$route.params.userId +
            "/" +
            row.platformId +
            "/" +
            row.companyId +
            "/" +
            this.$route.params.nickName+
            "/" +
            this.$route.params.deptId +
            "/" +
            row.customName;
        this.$router.push({
          path: path,
          query: {
            list: row,
            activiteId: row.activiteId,
            instanceId: row.instanceId,
            shenPiListDetail: row.formData,
            againShenPiStaute: row.result,
            isAgainShenPi: true,
          },
        });
      } else {
        var path =
            "/approvalDetail/" +
            row.instanceId +
            "/" +
            row.flag +
            "/" +
            row.activiteId +
            "/" +
            this.$route.params.userId +
            "/" +
            this.$route.params.nickName;
        this.$router.push(path);
      }

    },

    // 下拉刷新
    onLoad() {
      this.loading = true;
      this.page = this.page + 1;
      this.getList();
    },
    // 设置 页面标题
    setDocumentTitle(status) {
      if (status == 1) {
        this.activeTab = 1;
        const title = "待处理"; // 动态计算或获取title
        document.title = title;
      }
      if (status == 2) {
        this.activeTab = 2;
        const title = "已处理"; // 动态计算或获取title
        document.title = title;
      }
      if (status == 3) {
        this.activeTab = 3;
        const title = "已发起"; // 动态计算或获取title
        document.title = title;
      }
      if (status == 4) {
        this.activeTab = 4;
        const title = "我收到的"; // 动态计算或获取title
        document.title = title;
      }
      this.getList();
    },

    // tab切换
    getActiveTab(val) {
      this.flag = val;
      this.page = 1;
      this.list = [];
      this.setDocumentTitle(val);
    },

    onSearch() {
      console.log(this.name);
      this.page = 1;
      this.list = [];
      this.getList();
    },
    onCancel() {
      this.name = null;
    },
  },
  created() {
    this.activeTab = Number(this.$route.params.status);
  },
  mounted() {
    this.flag = this.$route.params.status;
    this.setDocumentTitle(this.$route.params.status);
  },
};
</script>

<style scoped>
/deep/ .van-tab {
  font-family: PingFang SC;
  font-weight: 400;
  font-size: 13px;
  color: #999999;
  border-bottom: 1px solid #eaeaeb;
}

/deep/ .van-tab--active {
  color: #1e1e1e;
  font-weight: bold;
}

/deep/ .van-tabs__line {
  width: 18px;
  height: 3px;
  background: #1e1e1e;
  border-radius: 2px;
  bottom: 20px;
}

/deep/ .van-search {
  padding: 10px 12px 7px;
}

/deep/ .van-search__content {
  background-color: #ededef;
  border-radius: 7px;
  width: 80%;
  flex: none;
}

/deep/ .van-search .van-cell .van-field__left-icon {
  color: #9a9a9a;
}

.box {
  margin: auto;
  width: 92%;
  margin-top: 14px;
}

.top {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.box img,
.Name {
  width: 22px;
  height: 22px;
  line-height: 22px;
  border-radius: 4px;
  vertical-align: middle;
  margin-right: 7px;
  font-family: PingFang SC;
  font-weight: 400;
  font-size: 9px;
  background: #3c87f7;
  color: #fff;
  box-sizing: border-box;
  text-align: center;
}

.box .title {
  vertical-align: middle;
  font-family: PingFang SC;
  font-weight: bold;
  font-size: 16px;
  color: #1e1e1e;
}

.time {
  font-family: PingFang SC;
  font-weight: 400;
  font-size: 11px;
  color: #999999;
}

.des .time {
  font-size: 13px;
  line-height: 20px;
}

.result {
  font-family: PingFang SC;
  font-weight: 400;
  font-size: 13px;
  color: #48d25f;
  margin: 6px 0 15px;
}
</style>
